import { atom, useAtom, useAtomValue, useSetAtom } from "jotai";

export const paintedDoorModalOpenAtom = atom(false);

export const usePaintedDoorModalOpenState = () => useAtom(paintedDoorModalOpenAtom);
export const usePaintedDoorModalOpenValue = () => useAtomValue(paintedDoorModalOpenAtom);
export const useSetPaintedDoorModalOpen = () => useSetAtom(paintedDoorModalOpenAtom);
